module.exports = __webpack_public_path__ + "img/border.925fe726.svg";